import ReturnHome from 'es/app/components/error/ReturnHome';
import withSuspense from 'es/core/hocs/withSuspense';
import { useI18n } from 'es/core/hooks/useI18n';
import { FallbackProps } from 'react-error-boundary';
import { Logo } from 'es/app/components/logo';

import './styles.scss';
import classNames from 'classnames';
import { BootstrapStyles } from 'es/app/visuals/styles/BootstrapStyles';

const UnexpectedError = ({ error }: FallbackProps['error']) => {
    const { l10n } = useI18n('app', 'error');
    const stackTrace = error?.stack ?? '';

    return (
        <div className={classNames('error-page', 'error-unexpected', BootstrapStyles['py-4'])}>
            <div className={classNames('title', BootstrapStyles['mb-4'])}>
                <Logo />
                <h1>
                    <strong>{l10n('unexpected.title')}</strong>
                </h1>
            </div>

            <div className="error-message">
                <label className="error-message-label">{l10n('unexpected.error', { suffix: ': ' })}</label>
                <p>{error && error.toString()}</p>
            </div>

            {stackTrace && (
                <div className="error-stacktrace">
                    <label>{l10n('unexpected.stackTrace', { suffix: ': ' })}</label>
                    <div className="trace" dangerouslySetInnerHTML={{ __html: convertStackTraceToHtml(stackTrace) }} />
                </div>
            )}
            <ReturnHome />
        </div>
    );
};

function convertStackTraceToHtml(stack: string): string {
    return stack
        .split('\n')
        .filter(line => !!line)
        .map(line => {
            return line && `<p>${line.replace(/^\s{2,}/g, ' ')}</p>`;
        })
        .join('\n');
}

export default withSuspense(UnexpectedError);
